import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import { createCostType, deleteCostType, getCostTypes, updateCostType } from './costTypes.actions';
import { CostType } from './costTypes.types';

export type CostTypesState = CostType[];

const initialState: CostTypesState = [];

const costTypesReducer = createReducer(initialState, {
  [getCostTypes.done.type]: (_state: CostTypesState, action: ReturnType<typeof getCostTypes.done>) => {
    return action.payload.result;
  },
  [createCostType.done.type]: (state: CostTypesState, action: ReturnType<typeof createCostType.done>) => {
    return [...state, action.payload.result];
  },
  [updateCostType.done.type]: (state: CostTypesState, action: ReturnType<typeof updateCostType.done>) => {
    const updatedLotType = action.payload.result;
    const indexFound = state.findIndex((lotType) => lotType.id === updatedLotType.id);
    return dotProp.set(state, indexFound, updatedLotType);
  },
  [deleteCostType.done.type]: (state: CostTypesState, action: ReturnType<typeof deleteCostType.done>) => {
    const deletedLotTypeId = action.payload.result;
    const indexFound = state.findIndex((lotType) => lotType.id === deletedLotTypeId);
    return dotProp.delete(state, indexFound);
  },
});

export default costTypesReducer;
